import { useParams } from "react-router-dom";
import Header from "../components/Header";
import { useQuery } from "@tanstack/react-query";
import DetailView from "../components/ContentDetail/DetailView";
import { getEducationSingle } from "../api";
export default function EducationDetail() {
  const { educationId } = useParams();

  const educationQuery = useQuery({
    queryKey: ["education", educationId],
    queryFn: getEducationSingle,
  });

  return <DetailView data={educationQuery.data} />;
}
